import { Reference } from 'common/reference/reference.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { FlexBlocks, FlexBoxProps, FlexDirection } from 'components.layout/flex-blocks.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { IColumnLayout } from 'redux-state/layout/types.modules.js';
import { IntegrationGeneralItem } from './integration-item-raw.js';
import { IntegrationGeneralType, IntegrationsConfigWrapper } from './types.js';

export const IntegrationsGeneralEntry = (props: IModule<IntegrationGeneralType>) => {
  const columnLayout = useContext(ColumnLayoutContext);
  return <IntegrationsGeneral {...props} columnLayout={columnLayout} />;
};

/** Also used on city-forecast */
export const IntegrationsContent = ({
  config,
  dir,
  parentClasses,
  classes,
  tag,
}: {
  config: IntegrationGeneralType;
  tag?: string;
} & Pick<FlexBoxProps, 'dir' | 'parentClasses' | 'classes'>) => {
  const { sumItems, mainSponsor } = config;
  return (
    <>
      <FlexBlocks dataModule="mcp-int-1" dir={dir} parentClasses={parentClasses} classes={classes} tag={tag}>
        {sumItems.map((s) => {
          return <IntegrationGeneralItem key={s.itemProps?.title ?? ''} summaryData={s} />;
        })}
      </FlexBlocks>

      <Reference
        {...mainSponsor}
        image={mainSponsor?.sponsorImage}
        text={mainSponsor?.tagline}
        url={mainSponsor?.sponsorURL}
        minHeight={mainSponsor?.minHeight ?? 1}
        classes="u-mT-xs u-mB-xs"
      />
    </>
  );
};

/** Export for testing */
export const IntegrationsGeneral = ({
  config,
  modulePath,
  columnLayout,
}: IModule<IntegrationsConfigWrapper<IntegrationGeneralType>> & { columnLayout?: IColumnLayout }) => {
  const flexDir = columnLayout === '2-column' ? FlexDirection.row : FlexDirection.col;
  return (
    <Tile dataModule="integrations-general" config={config}>
      <div className="Tile-body IconWithText--container">
        <TileBodyHeaderV2 config={config} modulePath={modulePath} classes="u-mB-responsive u-mB-sm" />
        <IntegrationsContent config={config} dir={flexDir} />
      </div>
    </Tile>
  );
};
